import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CandidateDetailsService } from 'src/app/candidates-layout/operations/candidate-details.service';
import { ExamDetailsService } from 'src/app/exam-layout/operations/exam-details.service';
import { ExamScheduleService } from 'src/app/services/exam-schedule-service';
import { ExamService } from 'src/app/services/exam-service.service';
import { PopoverRef } from '../popover/popover-ref';
import { Observable, of } from 'rxjs';
import { map, startWith, switchMap } from 'rxjs/operators';
import { PopoverService } from '../popover/popover.service';
import { PauseUnpauseExamComponent } from 'src/app/exam-layout/operations/pause-unpause-exam/pause-unpause-exam.component';
import { SebInstructionUrlComponent } from 'src/app/exam-layout/operations/seb-instruction-url/seb-instruction-url.component';
import { OperationStatus } from 'src/app/exam-layout/operationstatus';
import { GridUtil } from 'src/app/components/grid/GridUtil';
import { ComplaintService } from 'src/app/services/complaint-services.service';
import { QuestionBankService } from 'src/app/questions-bank/question-bank.service';

@Component({
  selector: 'app-details-menu',
  templateUrl: './details-menu.component.html',
  styleUrls: ['./details-menu.component.scss']
})
export class DetailsMenuComponent implements OnInit {
  opOpen$: Observable<boolean> = of(false);
  details = [];
  currentRoute = "";
  constructor(private popoverRef: PopoverRef<DetailsMenuComponent>, private route: Router,
    private popoverService: PopoverService, private examService: ExamService, private candateMenu: CandidateDetailsService,
    private examSchService: ExamScheduleService, public operationStatus: OperationStatus, private examDetailsService: ExamDetailsService,
    private complaintService: ComplaintService, private questionBankService: QuestionBankService) {

  }

  ngOnInit() {
    this.currentRoute = this.route.routerState.snapshot.url.split('?')[0];
    //when route changes needs to be updated
    this.route.events.subscribe((e) => {
      this.currentRoute = '' + this.route.routerState.snapshot.url.split('?')[0];

      this.setDetailsMenu();
    });
    this.setDetailsMenu();
  }


  setDetailsMenu() {

    if (this.currentRoute == '/exams') {
      this.details = this.examDetailsService.examDetailsList();
    } else if (/^\/?exams\/\d+\/schedules(\/.*)?$/.test(this.currentRoute)
      || this.currentRoute.includes(`/exams/${this.examService.selectedExamIds}/schedules/${this.examSchService.selectedIds}`)) {
      this.details = this.examScheduleDetailsMenu;
    } else if (this.currentRoute == '/candidates' || this.currentRoute.includes('/candidates/view')) {
      this.details = this.candateMenu.deatilsCandidateList();
    } else if (this.currentRoute.includes('/complaints')) {
      this.details = this.examComplaintDetailsMenu;
    } else if (this.currentRoute.includes('/exam-groups')) {
      this.details = this.examGroupDetailsMenu;
    } else if (this.currentRoute.includes('/questions-bank')) {
      this.details = this.QuestionsBankDetailsMenu;
    }
  }

  get examScheduleDetailsMenu() {
    return [
      {
        icon: 'mat:quiz',
        label: 'Questions',
        route: `${this.currentRoute}/${this.examSchService.selectedIds}/questions`,
        id: 'examinationschedules_questions'
      },
      {
        icon: 'mat:assignment',
        label: 'Essay Answers',
        route: `${this.currentRoute}/${this.examSchService.selectedIds}/eassayanswers`,
        id: 'examinationschedules_essay_answers'
      },
      {
        icon: 'mat:backup_table',
        label: 'Backups',
        route: `${this.currentRoute}/${this.examSchService.selectedIds}/backups`,
        id: 'examinationschedules_backups'
      },
      {
        icon: 'mat:work_history',
        label: 'Added Time Log',
        route: `${this.currentRoute}/${this.examSchService.selectedIds}/addedtimelog`,
        id: 'examinationschedules_added_time_log'
      },
      {
        icon: 'mat:pending_actions',
        label: 'Paused Time Log',
        route: `${this.currentRoute}/${this.examSchService.selectedIds}/pausedtimelog`,
        id: 'examinationschedules_paused_time_log'
      },
      {
        icon: 'mat:flag',
        label: 'Flags',
        route: `${this.currentRoute}/${this.examSchService.selectedIds}/flags`,
        id: 'examinationschedules_flags'
      },

      // {
      //   icon: 'mat:assessment',
      //   label: 'SEB Instruction URL',
      //   route: `${this.currentRoute}/${this.examSchService.selectedIds}/sebinstructionurl`
      // },
      {
        icon: 'mat:live_help',
        label: 'View Ticket',
        route: `/complaints/examsch/${this.examSchService.selectedIds}`,
        id: 'examinationschedules_view_complaints'
      },
    ];
  }
  get examComplaintDetailsMenu() {
    let selectedCompalint = this.complaintService.selectedComplaints?.[0];
    return [
      {
        icon: 'mat:rate_review',
        label: 'View Details',
        route: `/complaints/view`,
        id: 'complaint_send_response'
      },
      {
        icon: 'mat:assignment',
        label: 'View Candidate Details',
        route: {
          path: `/candidates/view`,
          queryParams: { mode: 'edit', examNo: selectedCompalint?.examNo }
        },
        id: 'complaint_send_response'
      },
      {
        icon: 'mat:assignment',
        label: 'View Schedule Details',
        route: {
          path: `/exams/${selectedCompalint?.examinationID}/schedules/${selectedCompalint?.examinationScheduleID}`,
          queryParams: { mode: 'edit', examschid: selectedCompalint?.examinationScheduleID }
        },
        id: 'complaint_send_response'
      },
      {
        icon: 'mat:playlist_play',
        label: 'View Examination Recordings',
        route: {
          path: `exams/${selectedCompalint?.examinationID}/recordings`,
          queryParams: { examid: `${selectedCompalint?.examinationID}`, candidateno: `${selectedCompalint?.examNo}` }
        },
        id: 'examinations_proctors'
      },
    ];
  }

  get examGroupDetailsMenu() {
    return [
      {
        icon: 'mat:assignment',
        label: 'Examinations',
        route: {
          path: '/exams',
          queryParams: { examGroupId: this.examService.selectedExamGroupIds }
        },
        id: 'examinations'
      },
    ];
  }

  get QuestionsBankDetailsMenu() {
    const selectedQB = this.questionBankService.selectedQuestionBanks?.[0];
    return [
      {
        icon: 'mat:assignment',
        label: 'View Questions',
        route: selectedQB ? `/questions-bank/${selectedQB.id}/questions` : '',
        id: 'questionbank_view_questions'
      },
    ];
  }

  async processOp(route: any, origin: any) {
    if (typeof route === 'string') {
      if (route.match('/exams/sebinstructionurl') || route.match(`${this.currentRoute}/${this.examSchService.selectedIds}/sebinstructionurl`)) {
        this.openSEBInstructionURL(origin);
      } else {
        if (route.includes('/schedules')) {
          GridUtil.setClearGridSelection();
        }
        const normalizedUrl = route.replace(/\?examNo=\d+/, '');
        this.route.navigate([normalizedUrl]);
      }
    } else if (typeof route === 'object' && route.path) {
      this.route.navigate([route.path], { queryParams: route.queryParams });
    }

    this.popoverRef.close();
  }

  openSEBInstructionURL(origin: any) {
    this.opOpen$ = of(
      this.popoverService.open({
        content: SebInstructionUrlComponent,
        origin,
        width: 2000,
        offsetY: 12,
        position: [
          {
            originX: 'end',
            originY: 'bottom',
            overlayX: 'end',
            overlayY: 'bottom'
          }, {
            originX: 'end',
            originY: 'bottom',
            overlayX: 'end',
            overlayY: 'bottom'
          }
        ]
      })
    ).pipe(
      switchMap(popoverRef => popoverRef.afterClosed$.pipe(map(() => false))),
      startWith(true),
    );
  }

  close() {
    this.popoverRef.close();
  }

  getRouteString(route: string | { path: string }): string {
    return typeof route === "string" ? route : route.path;
  }
}
